/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   CurrentSearchView constants
 */

export const BEGIN_SHIMMER = '@@nzr/CurrentSearchView/BEGIN_SHIMMER'
export const FINISH_SHIMMER = '@@nzr/CurrentSearchView/FINISH_SHIMMER'

export const SHOW_MARKERS = '@@nzr/CurrentSearchView/SHOW_MARKERS'
export const HIDE_MARKERS = '@@nzr/CurrentSearchView/HIDE_MARKERS'
